import request from '@/utils/request'

// 查询用户体重记录列表
export function listUserWeight(query) {
    return request({
        url: '/biz/userWeight/list',
        method: 'get',
        params: query
    })
}

// 查询用户体重记录详细
export function getUserWeight(id) {
    return request({
        url: '/biz/userWeight/' + id,
        method: 'get'
    })
}

// 新增用户体重记录
export function addUserWeight(data) {
    return request({
        url: '/biz/userWeight',
        method: 'post',
        data: data
    })
}

// 修改用户体重记录
export function updateUserWeight(data) {
    return request({
        url: '/biz/userWeight/update',
        method: 'post',
        data: data
    })
}

// 删除用户体重记录
export function delUserWeight(id) {
    return request({
        url: '/biz/userWeight/delete/' + id,
        method: 'post'
    })
}
